import { OptionMapper } from '../mapper/OptionMapper';

export const optionMapper = new OptionMapper();
